import React from "react";

export function ColumnMappingModalShell({
  title,
  contextLabel,
  contextChips = [],
  toolbar,
  actionCard,
  children,
  // Viewport-relative: this modal carries the whole column grid, so give it the
  // screen while keeping a readable ceiling on very wide displays.
  maxWidthClass = "tw-max-w-[min(96vw,1800px)]",
  heightClass = "tw-h-[min(92vh,calc(100vh-3rem))]"
}: {
  title: string;
  contextLabel?: string;
  contextChips?: string[];
  toolbar: React.ReactNode;
  actionCard: React.ReactNode;
  children: React.ReactNode;
  maxWidthClass?: string;
  heightClass?: string;
}): JSX.Element {
  return (
    <div className="tw-fixed tw-inset-0 tw-z-[3000] tw-flex tw-items-center tw-justify-center tw-bg-slate-900/60 tw-px-4 tw-py-6 sm:tw-px-6 tw-backdrop-blur-sm">
      <div
        className={`tw-relative tw-flex ${heightClass} tw-w-full ${maxWidthClass} tw-flex-col tw-overflow-hidden tw-rounded-3xl tw-border tw-border-slate-200 tw-bg-white tw-shadow-2xl`}
      >
        <header className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-slate-200 tw-px-6 tw-py-4">
          <div>
            <h2 className="tw-text-lg tw-font-semibold tw-text-slate-900">{title}</h2>
            {contextLabel && contextChips.length ? (
              <div className="tw-mt-1 tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                <span className="tw-text-[0.65rem] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-slate-500">
                  {contextLabel}
                </span>
                {contextChips.map((chip) => (
                  <span
                    key={chip}
                    className="tw-rounded-full tw-bg-slate-100 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-slate-700"
                  >
                    {chip}
                  </span>
                ))}
              </div>
            ) : null}
          </div>
        </header>
        <div className="tw-flex-1 tw-overflow-auto tw-px-6 tw-py-4">
          <div className="tw-space-y-4">
            <div className="tw-mt-4 tw-grid tw-grid-cols-1 tw-gap-4 lg:tw-grid-cols-[minmax(0,1fr)_20rem] lg:tw-items-start">
              <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">{toolbar}</div>
              <div className="tw-flex tw-flex-col tw-gap-2 lg:tw-items-end">{actionCard}</div>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
